import { ReactNode } from 'react'

interface Props {
    children: ReactNode
}

export default function Content({ children }: Props) {
    return <div className="mx-auto max-w-[1040px]">{children}</div>
}
